import React, { useCallback, useEffect, useState } from "react";
import {
  getPaymentInvoice,
  initializeTransaction,
} from "../services/invoicePayment";
import toast from "react-hot-toast";
import Spinner from "../components/Spinner";
import InvoiceTemplateOne from "./Templates/InvoiceTemplateOne";
import InvoiceTemplateTwo from "./Templates/InvoiceTemplateTwo";
import InvoiceTemplateThree from "./Templates/InvoiceTemplateThree";

const InvoiceWidget = () => {
  const [invoiceData, setInvoiceData] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [updatedTotalAmount, setUpdatedTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");

  const fetchInvoiceData = useCallback(async () => {
    try {
      const res = await getPaymentInvoice(code);
      setInvoiceData(res.data);
      // Initialize selected items with all item IDs
      const allItemIds = res.data.items.map((item) => item.id);
      setSelectedItems(allItemIds);

      // Set the initial total amount from the endpoint
      setUpdatedTotalAmount(res.data.totalAmount);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  }, [code]);

  useEffect(() => {
    fetchInvoiceData();
  }, [fetchInvoiceData]);

  const handleCheckboxChange = (id, price, quantity) => {
    const isItemChecked = selectedItems.includes(id);
    let newTotalAmount = updatedTotalAmount;
    let newSelectedItems = [...selectedItems];

    if (isItemChecked) {
      // Uncheck the item: remove its ID and subtract its total
      newSelectedItems = newSelectedItems.filter((itemId) => itemId !== id);
      newTotalAmount -= price * quantity;
    } else {
      // Check the item: add its ID and add its total
      newSelectedItems.push(id);
      newTotalAmount += price * quantity;
    }

    setSelectedItems(newSelectedItems);
    setUpdatedTotalAmount(newTotalAmount);
  };

  const proceedPayment = async () => {
    setLoading(true);
    try {
      const res = await initializeTransaction({
        items: selectedItems,
        invoiceId: invoiceData.id,
      });
      toast.success(res.message);
      setLoading(false);
      window.location.href = `https://pay.mypayloft.com/${res.data}`;
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <>
      {invoiceData?.invoiceType === 1 && (
        <InvoiceTemplateOne
          invoiceData={invoiceData}
          selectedItems={selectedItems}
          updatedTotalAmount={updatedTotalAmount}
          loading={loading}
          proceedPayment={proceedPayment}
          handleCheckboxChange={handleCheckboxChange}
        />
      )}
      {invoiceData?.invoiceType === 2 && (
        <InvoiceTemplateTwo
          invoiceData={invoiceData}
          selectedItems={selectedItems}
          updatedTotalAmount={updatedTotalAmount}
          loading={loading}
          proceedPayment={proceedPayment}
          handleCheckboxChange={handleCheckboxChange}
        />
      )}
      {invoiceData?.invoiceType === 3 && (
        <InvoiceTemplateThree
          invoiceData={invoiceData}
          selectedItems={selectedItems}
          updatedTotalAmount={updatedTotalAmount}
          loading={loading}
          proceedPayment={proceedPayment}
          handleCheckboxChange={handleCheckboxChange}
        />
      )}
    </>
  );
};

export default InvoiceWidget;
